var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 100 100" },
      attrs: {
        id: "Layer_1",
        version: "1.1",
        viewBox: "0 0 100 100",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("svg:style", { attrs: { type: "text/css" } }, [
        _vm._v(
          "\n        .st0 {\n            fill: url(#Background_13_);\n        }\n        .st1 {\n            fill: url(#path-2_7_);\n        }\n        .st2 {\n            filter: url(#Adobe_OpacityMaskFilter);\n        }\n        .st3 {\n            fill: #ffffff;\n        }\n        .st4 {\n            mask: url(#mask-3_1_);\n            fill: #ffffff;\n        }\n        .st5 {\n            fill: url(#SVGID_1_);\n        }\n        .st6 {\n            fill: #1e1e1f;\n        }\n        .st7 {\n            fill: url(#Oval_6_);\n        }\n        .st8 {\n            stroke: #000000;\n            stroke-width: 0.3;\n        }\n        .st9 {\n            fill: #2b2a2a;\n        }\n        .st10 {\n            fill: #ff9500;\n        }\n        .st11 {\n            fill: url(#Background_14_);\n        }\n        .st12 {\n            fill: url(#path-2_8_);\n        }\n        .st13 {\n            filter: url(#Adobe_OpacityMaskFilter_1_);\n        }\n        .st14 {\n            mask: url(#mask-3_2_);\n        }\n        .st15 {\n            fill: #ffffff;\n            fill-opacity: 0.7;\n        }\n        .st16 {\n            fill: url(#Background_15_);\n        }\n        .st17 {\n            fill: url(#Background_16_);\n        }\n        .st18 {\n            fill: url(#Background_17_);\n        }\n        .st19 {\n            filter: url(#Adobe_OpacityMaskFilter_2_);\n        }\n        .st20 {\n            mask: url(#mask-2_6_);\n            fill-opacity: 0.29;\n        }\n        .st21 {\n            filter: url(#Adobe_OpacityMaskFilter_3_);\n        }\n        .st22 {\n            mask: url(#mask-2_5_);\n        }\n        .st23 {\n            fill: url(#path-4_2_);\n        }\n        .st24 {\n            filter: url(#Adobe_OpacityMaskFilter_4_);\n        }\n        .st25 {\n            mask: url(#mask-2_4_);\n        }\n        .st26 {\n            fill: #aaaaaa;\n        }\n        .st27 {\n            fill: url(#Background_18_);\n        }\n        .st28 {\n            fill: #141416;\n        }\n        .st29 {\n            filter: url(#Adobe_OpacityMaskFilter_5_);\n        }\n        .st30 {\n            mask: url(#mask-2_3_);\n            fill: url(#Chart_1_);\n            stroke: #ffffff;\n            stroke-width: 0.75;\n        }\n        .st31 {\n            filter: url(#Adobe_OpacityMaskFilter_6_);\n        }\n        .st32 {\n            mask: url(#mask-2_2_);\n        }\n        .st33 {\n            fill: #01a6f1;\n        }\n        .st34 {\n            filter: url(#Adobe_OpacityMaskFilter_7_);\n        }\n        .st35 {\n            mask: url(#mask-2_1_);\n            fill: #777778;\n        }\n        .st36 {\n            fill: url(#Background_19_);\n        }\n        .st37 {\n            fill: #2e2e30;\n        }\n        .st38 {\n            fill: #7f7f7f;\n        }\n        .st39 {\n            fill: #777777;\n        }\n        .st40 {\n            fill: none;\n        }\n        .st41 {\n            fill: url(#SVGID_2_);\n        }\n        .st42 {\n            fill: url(#Oval_7_);\n        }\n        .st43 {\n            filter: url(#Adobe_OpacityMaskFilter_8_);\n        }\n        .st44 {\n            mask: url(#mask-3_3_);\n            fill: #ff1414;\n        }\n        .st45 {\n            filter: url(#Adobe_OpacityMaskFilter_9_);\n        }\n        .st46 {\n            mask: url(#mask-2_8_);\n        }\n        .st47 {\n            fill: #1badf8;\n        }\n        .st48 {\n            fill: #63da38;\n        }\n        .st49 {\n            filter: url(#Adobe_OpacityMaskFilter_10_);\n        }\n        .st50 {\n            mask: url(#mask-2_7_);\n        }\n        .st51 {\n            fill: #b7b7b7;\n        }\n        .st52 {\n            filter: url(#Adobe_OpacityMaskFilter_11_);\n        }\n        .st53 {\n            mask: url(#mask-2_24_);\n            fill: url(#Red_1_);\n        }\n        .st54 {\n            filter: url(#Adobe_OpacityMaskFilter_12_);\n        }\n        .st55 {\n            mask: url(#mask-2_23_);\n            fill: url(#Orange_1_);\n        }\n        .st56 {\n            filter: url(#Adobe_OpacityMaskFilter_13_);\n        }\n        .st57 {\n            mask: url(#mask-2_22_);\n            fill: url(#Yellow_1_);\n        }\n        .st58 {\n            filter: url(#Adobe_OpacityMaskFilter_14_);\n        }\n        .st59 {\n            mask: url(#mask-2_21_);\n            fill: url(#Green_1_);\n        }\n        .st60 {\n            filter: url(#Adobe_OpacityMaskFilter_15_);\n        }\n        .st61 {\n            mask: url(#mask-2_20_);\n            fill: url(#Turquoise_1_);\n        }\n        .st62 {\n            filter: url(#Adobe_OpacityMaskFilter_16_);\n        }\n        .st63 {\n            mask: url(#mask-2_19_);\n            fill: url(#Blue_1_);\n        }\n        .st64 {\n            filter: url(#Adobe_OpacityMaskFilter_17_);\n        }\n        .st65 {\n            mask: url(#mask-2_18_);\n            fill: url(#Purple_1_);\n        }\n        .st66 {\n            filter: url(#Adobe_OpacityMaskFilter_18_);\n        }\n        .st67 {\n            mask: url(#mask-2_17_);\n            fill: url(#Pink_1_);\n        }\n        .st68 {\n            fill: url(#Background_20_);\n        }\n        .st69 {\n            fill: #353535;\n        }\n        .st70 {\n            fill: url(#SVGID_3_);\n        }\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "g",
        { attrs: { id: "Symbols" } },
        [
          _c(
            "linearGradient",
            {
              attrs: {
                gradientTransform: "matrix(60 0 0 -60 -17169 44901)",
                gradientUnits: "userSpaceOnUse",
                id: "path-2_7_",
                x1: "286.9831",
                x2: "286.9831",
                y1: "748.2662",
                y2: "746.7667",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#19e6ff" },
                attrs: { offset: "0" },
              }),
              _vm._v(" "),
              _c("stop", {
                staticStyle: { "stop-color": "#1e51ee" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st1",
            attrs: {
              d: "M63.6,5c9,0,13.5,0,18.4,1.5c5.3,1.9,9.5,6.1,11.4,11.4C95,22.8,95,27.4,95,36.4v27.2   c0,9,0,13.5-1.5,18.4c-1.9,5.3-6.1,9.5-11.4,11.4C77.1,95,72.6,95,63.6,95H36.4c-9,0-13.5,0-18.4-1.5C12.6,91.5,8.5,87.4,6.5,82   C5,77.2,5,72.7,5,63.6V36.4c0-9,0-13.5,1.5-18.4C8.5,12.7,12.6,8.5,18,6.6C22.8,5,27.3,5,36.4,5H63.6z",
              id: "path-2_1_",
            },
          }),
          _vm._v(" "),
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  filterUnits: "userSpaceOnUse",
                  height: "58.1",
                  id: "Adobe_OpacityMaskFilter",
                  width: "66.2",
                  x: "17",
                  y: "21.5",
                },
              },
              [
                _c("feColorMatrix", {
                  attrs: {
                    type: "matrix",
                    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "mask",
            {
              attrs: {
                height: "58.1",
                id: "mask-3_1_",
                maskUnits: "userSpaceOnUse",
                width: "66.2",
                x: "17",
                y: "21.5",
              },
            },
            [
              _c("g", { staticClass: "st2" }, [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M63.6,5c9,0,13.5,0,18.4,1.5c5.3,1.9,9.5,6.1,11.4,11.4C95,22.8,95,27.4,95,36.4v27.2     c0,9,0,13.5-1.5,18.4c-1.9,5.3-6.1,9.5-11.4,11.4C77.1,95,72.6,95,63.6,95H36.4c-9,0-13.5,0-18.4-1.5C12.6,91.5,8.5,87.4,6.5,82     C5,77.2,5,72.7,5,63.6V36.4c0-9,0-13.5,1.5-18.4C8.5,12.7,12.6,8.5,18,6.6C22.8,5,27.3,5,36.4,5H63.6z",
                    id: "path-2_2_",
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("path", {
            staticClass: "st4",
            attrs: {
              d: "M25.3,68.3c0.1-0.2,0.3-0.3,0.5-0.4c0.8-0.2,1.6-0.4,2.4-0.4c2.2,0,4.2,0.8,5.8,2.2   c0.2,0.2,0.2,0.5,0.1,0.7l-4.1,7c-0.8,1.4-2.3,2.2-3.8,2.2c-0.9,0-1.8-0.3-2.6-0.9c-1.8-1.3-2.2-3.9-1.1-5.8L25.3,68.3z M78.6,57.6   c2.3,0,4.3,1.7,4.5,3.9c0.2,2.6-1.8,4.8-4.3,4.8h-5.3l3.9,6.7c1.1,1.9,0.7,4.5-1.1,5.8c-0.8,0.6-1.7,0.9-2.6,0.9   c-1.5,0-3-0.8-3.8-2.2l-9.4-16.3l-7.4-12.8c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.5-0.1-1-0.1-1.5c0-3.5,0.8-7,2.4-9.8   c0.2-0.3,0.7-0.3,0.9,0l12.2,20.8H78.6z M55.6,57.8c2.2,1.3,3.6,3.8,3.6,6.6c0,0.6-0.1,1.1-0.2,1.7c0,0.1-0.2,0.2-0.3,0.2h-14H21.4   c-2.5,0-4.6-2.2-4.3-4.8c0.2-2.3,2.2-3.9,4.5-3.9h9.9l13.5-23.2l-3.7-6.3c-1.3-2.2-0.4-5.1,2-6.1c2.1-0.9,4.5,0,5.7,1.9l1.1,1.9   l1.2-2c1.3-2.2,4.2-2.9,6.3-1.4c1.9,1.3,2.3,3.9,1.1,5.9L41.5,57.6h7h6.4C55.2,57.6,55.4,57.7,55.6,57.8z",
              id: "Icon",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }